export default __webpack_public_path__ + "static/media/BusinessintheTimeofContagion.8989136f.jpeg";